/*
  LB v1.3.0 — Globo product card enhancements (Flex card template)
  LB v1.4.0 — results count shows cards (prints), not products
  LB v1.4.1 — count also refreshes when Globo edits the summary text in place
  LB v1.5.0 — mockup card: short title, "Print · ★ rating", swatch dots (+N),
              "Available in N prints" link, price; NEW / BESTSELLER badges on image.
              Styles: assets/lb-card-2026.css
  LB v1.6.0 — shows the Family hero Original callout only when every visible card is an Original
  LB v1.7.0 — active-filter chips ("Medium ×") next to the results count
  LB v1.8.0 — "Best for" filter group collapsed by default (remembers the shopper's open/close)
  LB v1.13.0 — BESTSELLER per print (established prints only)
  LB v1.12.0 — NEW badge per print (variant print_launch_year), not per product
  LB v1.9.1 — grid columns: 2 on mobile (≤798px), 3 on desktop, via layout-grid's shadow DOM

  For each card Globo renders in #gf-grid:
  1. Identifies the card's variant (print) by matching the card's main image
     file name to the variant's image, falling back to the " - <Print>" title suffix.
  2. Hover image: swaps the secondary image to that variant's first
     custom.lifestyle_images image. For print products with no lifestyle image
     yet, removes the swap (Flex would otherwise show product.images[1],
     i.e. a different print).
  3. Points the card's links at ?variant=<id> so a split card opens the PDP
     on the print that was clicked.

  Data comes from /products/<handle>?view=lb-card-data (templates/product.lb-card-data.liquid).
*/
(function () {
  var cache = {};

  function fileStem(url) {
    if (!url) return '';
    var name = url.split('?')[0].split('/').pop();
    name = name.replace(/\.[a-z0-9]+$/i, '');
    return name.replace(/_\d+x\d*$|_x\d+$/, ''); // strip legacy size suffixes
  }

  function getData(handle) {
    if (!cache[handle]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?view=lb-card-data', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) { try { return t ? JSON.parse(t) : null; } catch (e) { return null; } })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function handleFromCard(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function findVariant(card, data) {
    var main = card.querySelector('.product-image__wrapper img:not(.secondary)');
    var stem = main ? fileStem(main.currentSrc || main.getAttribute('src') || main.getAttribute('data-src') || '') : '';
    var i;
    if (stem) {
      for (i = 0; i < data.variants.length; i++) {
        var vs = data.variants[i].img;
        if (vs && (stem === vs || stem.indexOf(vs) === 0 || vs.indexOf(stem) === 0)) return data.variants[i];
      }
    }
    var titleEl = card.querySelector('.product-thumbnail__title');
    var title = titleEl ? titleEl.textContent.trim() : '';
    for (i = 0; i < data.variants.length; i++) {
      var suffix = ' - ' + data.variants[i].title;
      if (title.slice(-suffix.length) === suffix) return data.variants[i];
    }
    return null;
  }

  function setHover(card, url) {
    var sec = card.querySelector('img.secondary');
    if (!sec) return;
    ['src', 'data-src'].forEach(function (a) { sec.setAttribute(a, url); });
    ['srcset', 'data-srcset'].forEach(function (a) { sec.setAttribute(a, url + ' 720w'); });
  }

  function removeHover(card) {
    var sec = card.querySelector('img.secondary');
    if (sec) {
      var wrap = sec.closest('.image-element__wrap') || sec;
      var ns = wrap.nextElementSibling;
      if (ns && ns.tagName === 'NOSCRIPT') ns.remove();
      wrap.remove();
    }
    card.classList.remove('has-secondary-image-swap');
  }

  function setVariantLinks(card, handle, variantId) {
    card.querySelectorAll('a[href*="/products/' + handle + '"]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (/[?&]variant=/.test(href)) return;
      var parts = href.split('#');
      parts[0] += (parts[0].indexOf('?') > -1 ? '&' : '?') + 'variant=' + variantId;
      a.setAttribute('href', parts.join('#'));
    });
  }

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function variantUrl(data, id) {
    return data.url + (data.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + id;
  }

  // v1.5.0 — rebuild the caption and add badges to match the 2026 collection mockup
  var MAX_DOTS = 5;
  function buildCard(card, data, v) {
    var caption = card.querySelector('.thumbnail__caption');
    if (!caption) return;
    var url = data.print ? variantUrl(data, v.id) : data.url;

    var meta = [];
    if (data.print && v.print) meta.push('<span class="lb-card__print">' + esc(v.print) + '</span>');
    if (data.rating_count > 0 && data.rating > 0) {
      meta.push('<span class="lb-card__rating" aria-label="Rated ' + esc(data.rating) + ' out of 5"><span aria-hidden="true">★</span> ' + esc(Number(data.rating).toFixed(1)) + '</span>');
    }

    var dots = '';
    if (data.print && data.variants.length > 1) {
      var others = [v].concat(data.variants.filter(function (x) { return x.id !== v.id; }));
      var shown = others.slice(0, MAX_DOTS).map(function (x) {
        var style = x.swi ? 'background-image:url(' + x.swi + ')' : (x.swc ? 'background-color:' + x.swc : '');
        return '<a class="lb-card__dot' + (x.id === v.id ? ' is-current' : '') + '" href="' + esc(variantUrl(data, x.id)) +
          '" style="' + esc(style) + '" title="' + esc(x.print) + '" aria-label="' + esc(x.print) + '"></a>';
      }).join('');
      var more = others.length - MAX_DOTS;
      dots = '<div class="lb-card__dots">' + shown + (more > 0 ? '<span class="lb-card__more">+' + more + '</span>' : '') + '</div>';
    }

    var avail = (data.print && data.prints > 1)
      ? '<a class="lb-card__avail" href="' + esc(variantUrl(data, v.id)) + '#print-selector">Available in ' + data.prints + ' prints</a>'
      : '';

    var price = v.compare
      ? '<span class="lb-card__price-now is-sale">' + v.price + '</span> <s class="lb-card__price-was">' + v.compare + '</s>'
      : '<span class="lb-card__price-now">' + v.price + '</span>';

    caption.className = 'thumbnail__caption lb-card__caption';
    caption.innerHTML =
      '<a class="lb-card__title" href="' + esc(url) + '">' + esc(data.title) + '</a>' +
      (meta.length ? '<div class="lb-card__meta">' + meta.join('<span class="lb-card__sep" aria-hidden="true"> · </span>') + '</div>' : '') +
      dots + avail +
      '<div class="lb-card__price">' + price + '</div>';

    // v1.12.0: NEW is per print (v.isnew); product-level badges (BESTSELLER) from data.badges
    // v1.13.0: BESTSELLER per print too (established prints only)
    // v1.15.0: ORIGINAL per print (carried-over prints of Original products), top-left like NEW (never both)
    var badgeHtml = (v.isorig ? '<span class="lb-badge lb-badge--original" role="img" aria-label="Original print"><span class="lb-badge__star" aria-hidden="true">★</span><span class="lb-badge__text">ORIGINAL</span></span>' : '') +
      (v.isnew ? '<span class="lb-badge lb-badge--new" role="img" aria-label="New print"><span class="lb-badge__text">NEW</span></span>' : '') +
      (v.isbest ? '<span class="lb-badge lb-badge--bestseller" role="img" aria-label="Bestseller"><span class="lb-badge__text">BESTSELLER</span></span>' : '');
    if (badgeHtml) {
      var wrap = card.querySelector('.product-image__wrapper');
      if (wrap && !wrap.querySelector('.lb-card__badges')) {
        var b = document.createElement('div');
        b.className = 'lb-card__badges';
        b.innerHTML = badgeHtml;
        wrap.appendChild(b);
      }
    }
    card.classList.add('lb-card');
  }

  function processCard(card) {
    if (card.hasAttribute('data-lb-enhanced')) return;
    card.setAttribute('data-lb-enhanced', 'pending');
    var handle = handleFromCard(card);
    if (!handle) return;
    getData(handle).then(function (data) {
      if (!data || !data.variants) { card.setAttribute('data-lb-enhanced', 'nodata'); return; }
      var v = findVariant(card, data);
      if (!v) { card.setAttribute('data-lb-enhanced', 'nomatch'); return; }
      if (data.print && data.variants.length > 1) setVariantLinks(card, handle, v.id);
      if (v.life) setHover(card, v.life);
      else if (data.print) removeHover(card);
      buildCard(card, data, v);
      card.setAttribute('data-lb-original', data.original ? 'true' : 'false');
      updateCallout();
      card.setAttribute('data-lb-enhanced', v.life ? 'lifestyle' : 'nolifestyle');
    });
  }

  function scan() {
    var grid = document.getElementById('gf-grid');
    if (!grid) return;
    grid.querySelectorAll('.thumbnail.product__grid-item').forEach(processCard);
  }

  // v1.4.0: Globo's ".gf-summary" counts products (pagination is by product).
  // With variants split into cards, show the number of cards instead:
  // "15 results". If Globo has more pages of products, the count is what's
  // loaded so far, shown with a "+".
  function updateCount() {
    var grid = document.getElementById('gf-grid');
    if (!grid) return;
    var cards = grid.querySelectorAll('.thumbnail.product__grid-item').length;
    var state = window.globofilter && globofilter.state;
    var morePages = !!(state && state.pagination && state.pagination.total_pages > 1) ||
      !!grid.querySelector('#gf_pagination_wrap .pagination a');
    var label = cards + (morePages ? '+' : '') + (cards === 1 && !morePages ? ' result' : ' results');
    document.querySelectorAll('.gf-summary').forEach(function (el) {
      // v1.9.3: compare visible text (Globo can rewrite it after we set it)
      if (el.textContent.replace(/\s+/g, ' ').trim() === label) return;
      el.setAttribute('data-lb-count', label);
      el.innerHTML = '<b>' + label.replace(/ .*/, '') + '</b> ' + label.replace(/^\S+ /, '');
    });
  }

  // v1.6.0 — Original Medium callout: visible only if all visible cards are Originals
  function updateCallout() {
    var callout = document.querySelector('[data-lb-original-callout]');
    var grid = document.getElementById('gf-grid');
    if (!callout || !grid) return;
    var cards = grid.querySelectorAll('.thumbnail.product__grid-item');
    if (!cards.length) { callout.hidden = true; return; }
    for (var i = 0; i < cards.length; i++) {
      var o = cards[i].getAttribute('data-lb-original');
      if (o === null) return;            // still loading — decide when data arrives
      if (o !== 'true') { callout.hidden = true; return; }
    }
    callout.hidden = false;
  }

  // v1.7.0 — chips for active filters, placed before the results count.
  // Each chip clicks Globo's own filter button, so Globo stays in control of state.
  function updateChips() {
    var summary = document.querySelector('#gf-controls-container .gf-summary');
    var tree = document.getElementById('gf-tree');
    if (!summary || !tree) return;
    var active = tree.querySelectorAll('.gf-option-block button[aria-checked="true"]');
    var key = Array.prototype.map.call(active, function (b) { return b.getAttribute('aria-label'); }).join('|');
    var box = document.querySelector('.lb-chips');
    if (box && box.getAttribute('data-key') === key && box.nextElementSibling === summary) return;
    if (box) box.remove();
    if (!active.length) return;
    box = document.createElement('span');
    box.className = 'lb-chips';
    box.setAttribute('data-key', key);
    Array.prototype.forEach.call(active, function (btn) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'lb-chip';
      var label = btn.getAttribute('aria-label') || btn.textContent.trim();
      chip.setAttribute('aria-label', 'Remove filter: ' + label);
      chip.innerHTML = esc(label) + ' <span class="lb-chip__x" aria-hidden="true">×</span>';
      chip.addEventListener('click', function () { btn.click(); });
      box.appendChild(chip);
    });
    if (active.length > 1) {
      var clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'lb-chips__clear';
      clear.textContent = 'Clear all';
      clear.addEventListener('click', function () {
        var all = tree.querySelector('.gf-clear-all, .globo-selected-items-wrapper .gf-clear, a[aria-label*="Clear all"], button[aria-label*="Clear all"]');
        if (all) { all.click(); return; }
        Array.prototype.forEach.call(tree.querySelectorAll('.gf-option-block button[aria-checked="true"]'), function (b) { b.click(); });
      });
      box.appendChild(clear);
    }
    summary.parentNode.insertBefore(box, summary);
  }

  // v1.8.0 — groups collapsed by default (Price/Availability are collapsed in Globo's own settings)
  var COLLAPSED_GROUPS = ['best for'];
  var groupOpen = {};               // shopper's choice per group, survives Globo re-renders
  function blockName(block) {
    var t = block.querySelector('.gf-block-title h3, .gf-block-title .h3');
    return t ? t.textContent.trim().toLowerCase() : '';
  }
  function applyCollapsed() {
    var tree = document.getElementById('gf-tree');
    if (!tree) return;
    tree.querySelectorAll('.gf-option-block').forEach(function (block) {
      var name = blockName(block);
      if (COLLAPSED_GROUPS.indexOf(name) === -1) return;
      if (!block.hasAttribute('data-lb-collapse')) {
        block.setAttribute('data-lb-collapse', '');
        var title = block.querySelector('.gf-block-title');
        if (title) title.addEventListener('click', function () {
          setTimeout(function () { groupOpen[name] = !block.classList.contains('is-collapsed'); }, 0);
        });
      }
      var wantOpen = !!groupOpen[name];
      if (!wantOpen && !block.classList.contains('is-collapsed')) block.classList.add('is-collapsed');
      if (wantOpen && block.classList.contains('is-collapsed')) block.classList.remove('is-collapsed');
    });
  }

  // v1.9.1 — Flex's <layout-grid> sets --_columns inside its (open) shadow root,
  // so outside CSS can't change it. Add a rule there: 2 columns on mobile, 3 above.
  function fixGridColumns() {
    var lg = document.querySelector('#gf-grid layout-grid');
    if (!lg || !lg.shadowRoot || lg.shadowRoot.querySelector('style[data-lb-cols]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-lb-cols', '');
    st.textContent =
      '.layout-grid{--_columns:3 !important;width:100%;flex:1 1 100%;box-sizing:border-box;}' + // v1.12.1 fill width when host is display:flex
      '@media (max-width: 798px){.layout-grid{--_columns:2 !important;--_gap:28px 14px;gap:28px 14px !important;}}';
    lg.shadowRoot.appendChild(st);
  }

  function init() {
    scan();
    updateCount();
    applyCollapsed();
    fixGridColumns();
    // v1.4.1: also watch text edits — Globo updates the summary number in place
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; scan(); updateCount(); updateCallout(); updateChips(); applyCollapsed(); fixGridColumns(); });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
